@if (isLoading) {
  <div class="inventory-item-tab__spinner">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">{{ 'MESSAGES.LOADING' | translate }}</span>
    </div>
  </div>
}

@if (viewModel$ | async; as vm) {
  <div class="inventory-item-warehouse-tab" [formGroup]="overviewForm.form">
    @if (vm.isServiceItem) {
      <p class="inventory-item-warehouse-tab__notice inventory-item-warehouse-tab__notice--service" role="status">
        {{ 'COMPONENTS.GOODS.WAREHOUSE_TAB.SERVICE_NOTICE' | translate }}
      </p>
    } @else {
      @if (vm.previewFieldLabelKey) {
        <p class="inventory-item-warehouse-tab__notice">
          {{ 'COMPONENTS.INVENTORY_ITEM_OVERVIEW.PREVIEW_UPDATED' | translate: { field: (vm.previewFieldLabelKey | translate) } }}
        </p>
      }

      <div class="inventory-item-warehouse-tab__fields">
        @for (field of vm.fields; track field.controlName) {
          <app-dynamic-editable-field
            class="inventory-item-warehouse-tab__field"
            [formControlName]="field.controlName"
            layout="stacked"
            [inputType]="field.inputType ?? 'text'"
            inputClass="input-sm"
            [enumName]="field.enumName ?? ''"
            [selectItems]="field.selectItems"
            (updatedInput)="onPreviewFieldUpdate(field.controlName)"
          >
            <ng-template #labelTpl>
              <div class="inventory-item-warehouse-tab__field-label">
                {{ field.label | translate }}
              </div>
            </ng-template>
            <ng-template #contentTpl>
              <div class="inventory-item-warehouse-tab__field-value">
                @if (field.valueKey) {
                  {{ field.valueKey | translate }}
                } @else {
                  {{ field.value }}
                }
              </div>
            </ng-template>
          </app-dynamic-editable-field>
        }
      </div>
    }
  </div>
}
